import { render, staticRenderFns } from "./KTextField.vue?vue&type=template&id=1bdfd866&"
import script from "./KTextField.vue?vue&type=script&lang=ts&"
export * from "./KTextField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports